import React from 'react'
import { ArrowRightIcon } from '@phosphor-icons/react'
import { navigate } from 'gatsby';

const BasicCard = ({data, label = '', className='relative w-full md:w-56 lg:w-64 h-[220px] md:h-auto overflow-hidden cursor-pointer', link = "", ariaLabel = '', hideButton = false}) => {
  return (
    <React.Fragment>
      <div
        className={`${className}`}
        onClick={() => {
          if(link)
            navigate(link)
        }}
        aria-label={ariaLabel}
      >
        <img className="w-full object-cover" src={data?.image} alt={data?.name} />
        {label != "" && <div className="">{label}</div>}
        {!hideButton && (
          <button className="absolute md:relative flex items-center justify-center gap-x-2 w-40 md:w-full mt-2 border border-gray-300 bg-white py-2 text-xs md:text-sm bottom-0 right-0 m-4 md:m-0">
            {data?.label}
            <ArrowRightIcon size={16} weight="light" />
          </button>
        )}
      </div>
    </React.Fragment>
  );
}

export default BasicCard